module.exports = __webpack_public_path__ + "img/grafico1.9a9d202a.svg";